import { apiAdsAuthClient, apiAdsClient, apiAeroClient } from "~/plugins/http";
import { getCurrentBase } from "~/helpers/persistenceBase";
import {
  IRequestPageParams,
  IRequestPageResult,
  IRequestListResult,
  IGetBasesResult,
  IAuthToBaseResult,
  IRequestTypesResult,
  IGetRequestTypesParams,
  IAuthToBaseResultError,
  IRequestItem,
  IRequestHouseResult,
  IGetRequestHousesParams,
  IChangeRequestAuthorParams,
  ISetRequestWaiting,
  IChangeRequestTypeParams,
  IChangeRequestMalfunctionParams,
  IChangeRequestSourceParams,
  IRequestSourceTypesData,
  IChangeRequestPriorityParams,
  IGetPremissesWithAccountsParams,
  IPremiseData,
  IChangeRequestPhoneParams,
  IGetHousesForUserParams,
  IHousesForUserResult,
  IGetUserCompanyProfilesParams,
  IGetCompanyProfilesResult,
  IRequestTypesData,
  IGetMaterialTypesResult,
  IGetDepartmentsResult,
  IGetConsultantsResult,
  IGetConsultantsParams,
  IGetRequestPoolsResult,
  IAddHouseRequest,
  IChangeRequestCreationDateParams,
  IAddHouseRequestResult,
  IChangeConsultantParams,
  ISetSpecialCommentParams,
  IGetLastRequestSmartInfoDataByPremiseIDParams,
  IGetLastRequestSmartInfoDataByPremiseIDResult,
  IGetHelpDispatcherGeneralInfoHouseIDParams,
  IGetHelpDispatcherGeneralInfoHouseIDResult,
  IGetEmergencyWorksByHouseParams,
  IGetEmergencyWorksByHouseData,
  IGetLiftsForAccountParams,
  IGetLiftsResult,
  IGetLiftsForHouseParams,
  ILockRequestParams,
  ICloseRequestParams,
  ISetCustomTemplateParams,
  ICustomTemplate,
  IPerformRequestParams,
  IUnperformRequestParams,
  IUnlockRequestParams,
  IGetGroupsOfDistrinctsForUserResult,
  IGetHouseGroupsForUserResult,
  IRequestSearchParams,
  IRequestSearchResult,
  IRequestFullTextSearchParams,
  ICloseChildRequestsParams,
  IGetChildRequestsParams,
  IChildRequestListItem,
  ISubscribeObserverParams,
  IAddReminderParams,
  IDownloadBlankForPrintFileParams,
  IChangeDateStartReportParams,
  IChangeDesiredTimeParams,
  ISetReportDateParams,
  IEmployeesWhoSeeRequestParams,
  IEmployeesWhoSeeRequestItem,
  IUtilityShutdownListItem,
  IGetUtilityShutdownListParams,
  ICloseUtilityShutdownParams,
} from "~/types/requestsDispatcher";
import { ICommonResult, IDownloadFileResponse } from "~/types/common";
import { AxiosResponse } from 'axios';
const controllerName = "RequestsDispatcher";

export const getRequestPage = async (
  params: IRequestPageParams,
	token: string
): Promise<IRequestPageResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/${controllerName}/RequestPage`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getRequestDetailsItem = async (id: number, token: string): Promise<IRequestItem> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/${controllerName}/Details/${id}`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getList = async (token: string): Promise<IRequestListResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/${controllerName}/List`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getBases = async (): Promise<IGetBasesResult> => {
  try {
    const { data } = await apiAeroClient.get("/UserInfo/AdsBases");
    return data;
  } catch (error) {
    throw error;
  }
};

export const authToBase = async (
  base: string
): Promise<IAuthToBaseResult | IAuthToBaseResultError> => {
  try {
    const { data } = await apiAdsAuthClient.post(
      `${base}/Auth/AuthorizeRoofUser`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const changeRequestAuthor = async (
  params: IChangeRequestAuthorParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/ChangeRequestAuthor`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const changeRequestMalfunction = async (
  params: IChangeRequestMalfunctionParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/ChangeRequestMalfunction`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const changeRequestSource = async (
  params: IChangeRequestSourceParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/ChangeRequestSource`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getPremissesWithAccounts = async (
  params: IGetPremissesWithAccountsParams,
  token: string
): Promise<IPremiseData[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetPremissesWithAccounts`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const setRequestWaiting = async (
  params: ISetRequestWaiting,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/SetRequestWaiting`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const changeRequestType = async (
  params: IChangeRequestTypeParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/ChangeRequestType`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const changeRequestCreationDate = async (
  params: IChangeRequestCreationDateParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/ChangeRequestCreationDate`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const changeRequestPhone = async (
  params: IChangeRequestPhoneParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/ChangeRequestPhone`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const changeRequestPriority = async (
  params: IChangeRequestPriorityParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/ChangeRequestPriority`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const changeConsultant = async (
  params: IChangeConsultantParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/ChangeConsultant`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}


export const lockRequest = async (
  params: ILockRequestParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/LockRequest`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const closeRequest = async (
  params: ICloseRequestParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/CloseRequest`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const closeRequestLowMark = async (
  params: ICloseRequestParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/FixRequestLowMark`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const setCustomTemplate = async (
  params: ISetCustomTemplateParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportServiceData/SetCustomTemplate`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getTemplateMessages = async (
  token: string,
): Promise<ICustomTemplate[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetTemplateMessages`,
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const performRequest = async (
  params: IPerformRequestParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/PerformRequest`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const unperformRequest = async (
  params: IUnperformRequestParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/UnperformRequest`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const unlockRequest = async (
  params: IUnlockRequestParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/UnlockRequest`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const closeChildRequests = async (
  params: ICloseChildRequestsParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/CloseChildRequests`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getChildRequests = async (
  params: IGetChildRequestsParams,
  token: string,
): Promise<IChildRequestListItem[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportService/GetChildRequests`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const subscribeObserver = async (
  params: ISubscribeObserverParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/SubscribeObserver`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const addReminder = async (
  params: IAddReminderParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/AddReminder`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getTemplateFileNames = async (
  token: string,
): Promise<string[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetTemplateFileNames`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const downloadBlankForPrintFile = async (
  params: IDownloadBlankForPrintFileParams,
  token: string,
): Promise<IDownloadFileResponse> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    return await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/DownloadBlankForPrintFile`,
      {
        params,
        responseType: 'blob' 
      }
    );
  } catch (error) {
    throw error;
  }
}

export const changeDateStartReport = async (
  params: IChangeDateStartReportParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/ChangeDateStartReport`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const changeDesiredTime = async (
  params: IChangeDesiredTimeParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/ChangeDesiredTime`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const SetReportDate = async (
  params: ISetReportDateParams,
  token: string,
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/SetReportDate`,
      params
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getEmployeesWhoSeeRequest = async (
  params: IEmployeesWhoSeeRequestParams,
  token: string,
): Promise<IEmployeesWhoSeeRequestItem[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportService/EmployeesWhoSeeRequest`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getRequestTypes = async (
  params: IGetRequestTypesParams = {},
  token: string
): Promise<IRequestTypesResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/${controllerName}/RequestTypes`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getRequestTypesSupportService = async (
  params: IGetRequestTypesParams = {},
  token: string
): Promise<IRequestTypesData[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetRequestTypes`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getEmergencyWorksByHouse = async (
  params: IGetEmergencyWorksByHouseParams,
  token: string
): Promise<IGetEmergencyWorksByHouseData[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetEmergencyWorksByHouse`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getRequestSourceTypes = async (
  token: string
): Promise<IRequestSourceTypesData[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetRequestSourceTypes`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getRequestHouses = async (
  params: IGetRequestHousesParams = {},
  token: string
): Promise<IRequestHouseResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/${controllerName}/Houses`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getHousesForUser = async (
  params: IGetHousesForUserParams = {},
  token: string
): Promise<IHousesForUserResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetHousesForUser`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getUserCompanyProfiles = async (
  params: IGetUserCompanyProfilesParams,
  token: string
): Promise<IGetCompanyProfilesResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetUserCompanyProfiles`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getCompanyProfiles = async (
  token: string
): Promise<IGetCompanyProfilesResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetCompanyProfiles`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getHouseGroupsForUser = async (
  token: string
): Promise<IGetHouseGroupsForUserResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetHouseGroupsForUser`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getGroupsOfDistrinctsForUser = async (
  token: string
): Promise<IGetGroupsOfDistrinctsForUserResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetGroupsOfDistrinctsForUser`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getLiftsForAccount = async (
  params: IGetLiftsForAccountParams,
  token: string
): Promise<IGetLiftsResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetLiftsForAccount`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getLiftsForHouse = async (
  params: IGetLiftsForHouseParams,
  token: string
): Promise<IGetLiftsResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetLiftsForHouse`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getMaterialTypes = async (
  token: string
): Promise<IGetMaterialTypesResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetMaterialTypes`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getDepartments = async (
  token: string
): Promise<IGetDepartmentsResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetDepartments`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getConsultants = async (
  token: string,
  params?: IGetConsultantsParams
): Promise<IGetConsultantsResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetConsultants`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getAllConsultants = async (
  token: string,
): Promise<IGetConsultantsResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetAllConsultants`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getConsultantsToMoveRequest = async (
  token: string,
  RequestId: number
): Promise<IGetConsultantsResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetConsultantsToMoveRequest`,
      { 
        params: { RequestId } 
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getRequestPools = async (
  token: string,
): Promise<IGetRequestPoolsResult[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetRequestPools`,
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getLastRequestSmartInfoDataByPremiseID = async (
  token: string,
  params: IGetLastRequestSmartInfoDataByPremiseIDParams,
): Promise<IGetLastRequestSmartInfoDataByPremiseIDResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetLastRequestSmartInfoDataByPremiseID`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getHelpDispatcherGeneralInfoHouseID = async (
  token: string,
  params: IGetHelpDispatcherGeneralInfoHouseIDParams,
): Promise<IGetHelpDispatcherGeneralInfoHouseIDResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetHelpDispatcherGeneralInfoHouseID`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const addHouseRequest = async (
  params: IAddHouseRequest,
  token: string
): Promise<IAddHouseRequestResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);
    const baseName = getCurrentBase()
    const { data } = await adsClientInstance.post(
      `${baseName}/SupportService/AddRequest`,
      { ...params, baseName }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const addFile = async (
  formData: FormData,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/${controllerName}/AddFile`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const addMessage = async (
  params: {id: number, text: string, IsHidden?: boolean},
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);
    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/RequestsDispatcher/addMessage`,
      {
        RequestId: params.id,
        Text: params.text,
        IsHidden: params.IsHidden,
        DebtorsCasesPreTrialWorkTypeID: null,
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const changeMessageVisibility = async (
  params: {requestId: number, messageId: number, isHidden: boolean},
  token: string
): Promise<AxiosResponse> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const response = await adsClientInstance.post(
      `${getCurrentBase()}/RequestsDispatcher/ChangeMessageVisibility`,
    {
      requestID: params.requestId,
      messageID: params.messageId,
      isHidden: params.isHidden,
    },
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export const removeFile = async (
  params: {requestId: number, fileId: number},
  token: string
): Promise<AxiosResponse> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const response = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/RemoveFile`,
    {
      requestID: params.requestId,
      fileID: params.fileId,
    },
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export const downloadFile = async (
  id: number,
  token: string,
): Promise<AxiosResponse> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const response = await adsClientInstance.get(`${getCurrentBase()}/RequestsDispatcher/File/${id}`, {
      responseType: 'blob',
    });
    return response;
  } catch (error) {
    throw error;
  }
}


export const setSpecialComment = async (
  params: ISetSpecialCommentParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/SupportService/SetSpecialComment`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const performSearch = async (
  params: IRequestSearchParams,
  token: string
): Promise<IRequestSearchResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/${controllerName}/PerformSearch`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const performFullTextSearch = async (
  params: IRequestFullTextSearchParams,
  token: string
): Promise<IRequestSearchResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/${controllerName}/PerformFullTextSearch`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const debtorSearch = async (
  params: IRequestSearchParams,
  token: string
): Promise<IRequestSearchResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data } = await adsClientInstance.post(
      `${getCurrentBase()}/${controllerName}/PerformDebtorCaseSearch`,
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getMeters = async (
  ident: number,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data }  = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetMeters`, {
        params: {
          ident,
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getMetersValues = async (
  id: number,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data }  = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetMetersValues`, {
        params: {
          id,
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getMetersByPeriod = async (
  params: {ident: number, period: string},
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data }  = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetMetersByPeriod`, {
        params,
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
}


export const addMeterValueSimple = async (
  params: { meterId: number, value: string, valueT2: string, valueT3: string },
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data }  = await adsClientInstance.post(
      `${getCurrentBase()}/SupportServiceData/AddMeterValueSimple`, 
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}


export const addMeter = async (
  params: { meterId: number, value: string, valueT2: string, valueT3: string },
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data }  = await adsClientInstance.post(
      `${getCurrentBase()}/SupportServiceData/addMeter`, 
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getMeterValuesHistory = async (
  id: number,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data }  = await adsClientInstance.get(
      `${getCurrentBase()}/SupportServiceData/GetMeterValuesHistory`, {
        params: {
          id,
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export const getDebtorCasePage = async (
  params: IRequestPageParams,
	token: string
): Promise<IRequestPageResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);
    const { data } = await adsClientInstance.get(
      `${getCurrentBase()}/${controllerName}/DebtorCasePage`,
      { params }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getUtilityShutdowns = async (
  params: IGetUtilityShutdownListParams,
  token: string
): Promise<IUtilityShutdownListItem[]> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data }  = await adsClientInstance.post(
      `${getCurrentBase()}/SupportServiceData/GetUtilityShutdowns`, 
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const addUtilityShutdown = async (
  params: IGetUtilityShutdownListParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data }  = await adsClientInstance.post(
      `${getCurrentBase()}/SupportServiceData/AddUtilityShutdown`, 
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const closeUtilityShutdown = async (
  params: ICloseUtilityShutdownParams,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data }  = await adsClientInstance.post(
      `${getCurrentBase()}/SupportServiceData/CloseUtilityShutdown`, 
      { ...params }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteUtilityShutdown = async (
  id: number,
  token: string
): Promise<ICommonResult> => {
  try {
    const adsClientInstance = apiAdsClient(token);

    const { data }  = await adsClientInstance.post(
      `${getCurrentBase()}/SupportServiceData/DeleteUtilityShutdown`, 
      { id }
    );
    return data;
  } catch (error) {
    throw error;
  }
};
